import { useEffect, useState } from 'react'
import type { CaseEndpoint } from '../../../types/case-container'

export type DeleteStep = 'warning' | 'checking' | 'blocked' | 'confirm'
export type LinkedType = 'endpoint' | 'collection' | 'both'

export interface LinkedItem {
  endpoint: CaseEndpoint
  linkedType: LinkedType
}

function classifyLinkedType(endpoint: CaseEndpoint): LinkedType | null {
  const hasLinkedEndpoint = endpoint.linkedEndpointId !== null
  const hasLinkedCollection = endpoint.linkedCollectionId !== null
  if (hasLinkedEndpoint && hasLinkedCollection) return 'both'
  if (hasLinkedCollection) return 'collection'
  if (hasLinkedEndpoint) return 'endpoint'
  return null
}

function findLinkedItems(endpoints: CaseEndpoint[]): LinkedItem[] {
  const linked: LinkedItem[] = []
  for (const endpoint of endpoints) {
    const linkedType = classifyLinkedType(endpoint)
    if (linkedType) linked.push({ endpoint, linkedType })
  }
  return linked
}

export interface DeleteConfirmationModalState {
  step: DeleteStep
  linkedItems: LinkedItem[]
  handleProceed: () => void
}

export function useDeleteConfirmationModal(
  endpoints: CaseEndpoint[]
): DeleteConfirmationModalState {
  const [step, setStep] = useState<DeleteStep>('warning')
  const [linkedItems, setLinkedItems] = useState<LinkedItem[]>([])

  useEffect(() => {
    if (step !== 'checking') return
    const linked = findLinkedItems(endpoints)
    setLinkedItems(linked)
    setStep(linked.length > 0 ? 'blocked' : 'confirm')
  }, [step, endpoints])

  const handleProceed = (): void => {
    setStep('checking')
  }

  return { step, linkedItems, handleProceed }
}
